import { AppModule } from './app/app.module';
import { NestFactory } from '@nestjs/core';
import { SwaggerModule, DocumentBuilder } from '@nestjs/swagger';
import 'dotenv/config';
// import { salesConfigs } from '../config';
import { Logger, ValidationPipe } from '@nestjs/common';
import { HttpExceptionFilter, LoggingInterceptor } from '@gtpl/shared-utils/error-messages';
import { PinoLogger } from 'nestjs-pino';
import { NestJsLogger } from '../../logger/nest-js-logger';
import {appSettings} from '../../config';
import { anlayticsConfigs } from '../config';
//const port = salesConfigs.port;

async function bootstrap() {
  const app = await NestFactory.create(AppModule,
    { logger: new NestJsLogger( new PinoLogger({pinoHttp: {level: anlayticsConfigs.loggingMode}}) ) }
  );
  // app.enableCors(); 
  app.enableCors({
    origin: true,
    methods: 'GET,HEAD,PUT,PATCH,POST,DELETE,OPTIONS',
    // credentials: true,
});
const globalPrefix = 'erpx';
  app.setGlobalPrefix(globalPrefix);
  const port = appSettings.analytics_port;
  const options = new DocumentBuilder()
    .setTitle('ERPX')
    .setDescription('ERPX')
    .setVersion('1.0')
    .addTag('')
    .build();
  const document = SwaggerModule.createDocument(app, options);
  SwaggerModule.setup('erpx', app, document);
  // await app.listen(3000);
  await app.listen(port, () => {
    Logger.log('Listening at http://localhost:' + port + '/' + globalPrefix);
  });

}
bootstrap();